import React from 'react';
import { useCanvasStore } from '@/stores/canvasStore';
import { usePartnrBetaStore } from '@/stores/partnrBetaStore';
import { LayoutGrid, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function ClusterToggleButton() {
  const { isClusteringEnabled, setClusteringEnabled, spatialClusters, isDetectingClusters, viewMode, currentBoardId } = useCanvasStore();
  const { isPartnrBetaEnabled } = usePartnrBetaStore();

  // Hide if beta is disabled or not in focus mode
  if (!isPartnrBetaEnabled || viewMode !== 'focus' || !currentBoardId) return null;

  return (
    <div className="fixed top-[4.5rem] right-4 z-40">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => setClusteringEnabled(!isClusteringEnabled)}
            disabled={isDetectingClusters}
            className={cn(
              'p-2.5 rounded-xl shadow-lg border transition-all duration-200',
              'hover:scale-105 active:scale-95',
              'flex items-center justify-center',
              'bg-background/95 backdrop-blur-sm border-border',
              isDetectingClusters && 'opacity-70 cursor-wait',
              isClusteringEnabled
                ? 'bg-primary text-primary-foreground border-primary hover:bg-primary/90'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
            title={`${isClusteringEnabled ? 'Hide' : 'Analyze'} content clusters${spatialClusters.length > 0 ? ` (${spatialClusters.length})` : ''}`}
          >
            {isDetectingClusters ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <LayoutGrid className="h-5 w-5" strokeWidth={2} />
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>{isDetectingClusters ? 'Analyzing content...' : isClusteringEnabled ? 'Hide' : 'Analyze'} clusters{spatialClusters.length > 0 ? ` (${spatialClusters.length})` : ''}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
